import { normalizeResolvedPath } from '../../../paths/normalize-resolved-path.js';
import { yieldToEventLoop } from '../../../runtime/yield-to-event-loop.js';
import { fileBrowserReadInFlight } from '../../../files/browser/in-flight.js';
import { withCodeNavCacheSqlite, withCodeNavCacheSqliteProbe } from '../../../sqlite/code-nav-cache/database.js';
import type { CodeNavSymbolSpan } from '../../types.js';
import {
  loadFileTagRows,
  loadSymbolQuerySnapshot,
  spansFromSnapshot,
  spansFromSnapshotFast,
} from './build-symbol-spans.js';

/** Returns null when SQLite is locked (caller should treat as index not ready). */
export async function querySymbolsInFileFast(
  parentPath: string,
  filePath: string,
): Promise<CodeNavSymbolSpan[] | null> {
  if (fileBrowserReadInFlight()) return null;
  await yieldToEventLoop();
  const resolved = normalizeResolvedPath(parentPath);

  const spans = await withCodeNavCacheSqliteProbe((db) => {
    const rows = loadFileTagRows(db, resolved, filePath);
    if (rows == null) return null;
    return spansFromSnapshotFast(rows);
  });

  if (spans === undefined) return null;
  await yieldToEventLoop();
  return spans;
}

/** Full SQLite retry path for background / navigation ops. */
export async function querySymbolsInFile(parentPath: string, filePath: string): Promise<CodeNavSymbolSpan[]> {
  await yieldToEventLoop();
  const resolved = normalizeResolvedPath(parentPath);

  const spans = await withCodeNavCacheSqlite((db) => {
    const snapshot = loadSymbolQuerySnapshot(db, resolved, filePath);
    if (snapshot == null) return [];
    return spansFromSnapshot(filePath, snapshot);
  });

  await yieldToEventLoop();
  return spans;
}
